import { useState } from 'react';

import QuickViewButton from './QuickViewButton';
import QuickViewDialog from './QuickViewDialog';
import { QuickViewResponse } from './type';
import { getStatusCount } from 'services/api';

interface QuickViewProps {
  storeId: string;
  token: string;
}

const QuickView = ({ storeId, token }: QuickViewProps) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState<QuickViewResponse>();
  const [error, setError] = useState<string | null>(null);

  const fetchStatusCount = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await getStatusCount(token, storeId);

      setData(response);

      return response;
    } catch (err) {
      console.error('Failed to fetch status count', err);

      setError('Unable to load service item summary.');

      return null;
    } finally {
      setLoading(false);
    }
  };

  const loadData = async () => {
    const response = await fetchStatusCount();

    if (response) {
      setOpen(true);
    }
  };

  const refresh = async () => {
    await fetchStatusCount();
  };

  return (
    <>
      <QuickViewButton
        loading={loading}
        onOpen={loadData}
        onRefresh={refresh}
      />

      <QuickViewDialog
        open={open}
        data={data}
        error={error}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default QuickView;
